export enum BtnsPosition {
  CENTER = 'center',
  START = 'start',
  END = 'end',
}
